import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';

import Pill from './Pill';
import { CARD_ISSUANCE_STATE_STATUS } from 'utilities/constants';

const AccountActivationPill = ({ account, showActivated = true }) => {
  const issuanceState = account?.cardDetails?.issuanceState;

  const cardIsActivated =
    issuanceState === CARD_ISSUANCE_STATE_STATUS.ACTIVATED;

  const cardIsPreExpired =
    issuanceState === CARD_ISSUANCE_STATE_STATUS.PRE_EXPIRED;

  if (!showActivated && cardIsActivated) {
    return;
  }

  if (issuanceState) {
    return !cardIsActivated && !cardIsPreExpired ? (
      <Pill color="orange" icon={<ExclamationCircleOutlined />}>
        Not Activated
      </Pill>
    ) : (
      <Pill color="green" icon={<CheckCircleOutlined />}>
        Activated
      </Pill>
    );
  }
};

export default AccountActivationPill;
